/* eslint-disable react/prop-types */
// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from '../../../node_module_clones/react-router';

// Selector
import electronSelector from './electronSelector';

// Pulling out dispatch so it's not incorrectly added to the link element
const ElectronLink = ({ dispatch, isElectron, to, children, className, onClick, ...props }) =>
    isElectron ? (
        <a
            href={`https://app.milanote.com${to}`}
            className={className}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
        >
            {children}
        </a>
    ) : (
        <Link {...props} to={to} className={className} onClick={onClick}>
            {children}
        </Link>
    );

ElectronLink.propTypes = {
    isElectron: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
    to: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export default connect(electronSelector)(ElectronLink);
